'use strict';

// update place search results
const element_id = 'event_place_id:0';
const element_id_locale = 'event_location';

document.addEventListener('DOMContentLoaded', choices);
document.addEventListener('turbo:frame-load', choices);

function choices() {
    const element = document.getElementById(element_id);
    const choices = new Choices(element, {
        allowHTML: false,
        noResultsText: null,
        noChoicesText: null
    });

    const delay = 1000;
    let timeoutID = null;
    const input = element.parentNode.parentNode.getElementsByTagName('input')[0];
    input.addEventListener('input', function(event) {
        if (timeoutID) clearTimeout(timeoutID);
        timeoutID = setTimeout(setChoices, delay, event, choices);
    });
}

function setChoices(event, choices) {
    if(event.target.value) {
        const limit = 5
        const locale = document.getElementById(element_id_locale).dataset.locale
        choices.setChoices(function () {
            return fetch(
                `/places/autocomplete?name=${event.target.value}&limit=${limit}&locale=${locale}`
            )
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    return data.map(function (entry) {
                        return {value: entry.value, label: entry.name};
                    });
                });
        }, undefined, undefined, true);
    }
    else {
        choices.clearChoices();
    }
}
